<template>
  <RevDrawer
    :close-button-label="i18n(translations.closeButtonLabel)"
    :name="MODAL_NAMES.CONDITION_COMPARISON"
    :title="i18n(translations.drawerTitle)"
  >
    <template #body>
      <section>
        <h2 class="heading-1">
          {{ i18n(translations.section1Title) }}
        </h2>
        <p class="text-static-default-hi body-1 pt-24">
          {{ i18n(translations.section1Description) }}
        </p>

        <ComparisonArea
          v-if="shouldDisplayComparisonArea"
          :brand
          class="mt-24"
          :is-smartphone
        />
        <Checkpoints :category-id class="mt-24" />
        <LinkToVerifiedRefurbished class="mt-16" />
      </section>
    </template>
  </RevDrawer>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import ComparisonArea from '@backmarket/nuxt-layer-product-modals/ComparisonArea.vue'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevDrawer } from '@ds/components/Drawer'

import type { Option } from '~/scopes/product-core/components/presentationals/CustomizationFunnel/utils/types'
import { MODAL_NAMES, ProductCategory } from '~/scopes/product-core/constants'

import translations from './ConditionDescriptionModal.translations'
import Checkpoints from './components/Checkpoints/Checkpoints.vue'
import LinkToVerifiedRefurbished from './components/LinkToVerifiedRefurbished/LinkToVerifiedRefurbished.vue'

const i18n = useI18n()

const props = defineProps<{
  brand: string
  categoryId: string
  options?: Option[]
}>()

const shouldDisplayComparisonArea = computed(() => {
  // Using trackingValue as parameters.grade.value is not defined when the picker is out of stock.
  return props.options?.find((option) => option.trackingValue === '9')
})

const isSmartphone = computed(() => {
  return props.categoryId === ProductCategory.SMARTPHONE
})
</script>
